<template>
  <div class="sub_index">
    <header class="n-fixed-top bg-c bColor">
      <div class="left" v-if="$route.name !== 'index'">
        <router-link to="/main/index" class="n-back"></router-link>
        <!--<div class="n-back" ></div>-->
      </div>
      <h4>
        <span>{{ titleValue }}</span>
      </h4>
      <div class="right" v-if="$route.name !== 'index'"></div>
    </header>
    <div class="sub_main">
      <div class="sub_nav fl">
        <router-link
          to="sub_report"
          @click.native="setTitle('sub_index.tit_report')"
          ><i
            class="report"
            :class="{ cur: titleValue == this.$t('sub_index.tit_report') }"
            ><b></b></i
        ></router-link>
        <router-link
          to="sub_homework"
          @click.native="setTitle('sub_index.tit_homework')"
          ><i
            class="homework"
            :class="{ cur: titleValue == this.$t('sub_index.tit_homework') }"
            ><b></b></i
        ></router-link>
        <router-link
          to="sub_alfx"
          @click.native="setTitle('sub_index.tit_alfx')"
          ><i
            class="al"
            :class="{ cur: titleValue == this.$t('sub_index.tit_alfx') }"
            ><b></b></i
        ></router-link>
        <router-link
          to="sub_reflect"
          @click.native="setTitle('sub_index.tit_reflect')"
          ><i
            class="reflect"
            :class="{ cur: titleValue == this.$t('sub_index.tit_reflect') }"
            ><b></b></i
        ></router-link>
        <router-link to="sub_do" @click.native="setTitle('sub_index.tit_do')"
          ><i
            class="do"
            :class="{ cur: titleValue == this.$t('sub_index.tit_do') }"
            ><b></b></i
        ></router-link>
      </div>
      <div class="sub_con fl">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      titleValue: this.$route.name,
    };
  },
  mounted() {},
  methods: {
    setTitle(e) {
      this.titleValue = this.$t(e);
    },
  },
};
</script>
<style lang="scss" scoped>
$subNavWidth: 1.1rem;
.sub_index {
  font-family: MicrosoftYaHei;
  h4 {
    span {
      white-space: nowrap;
    }
  }
  .sub_main {
    padding-top: 0.12rem;
    background-color: #eee;
    min-height: calc(100vh - #{$topHeight});
    box-sizing: border-box;
    .sub_nav {
      background-color: #fff;
      width: $subNavWidth;
      /*border:1Px solid red;
         */
      min-height: calc(100vh - 0.84rem);
      a {
        display: inline-block;
        width: 1.1rem;
        height: 1.64rem;
        border-bottom: 0.04rem solid #f6f6f6;
        position: relative;
        i {
          display: inline-block;
          width: 0.6rem;
          height: 0.72rem;
          margin-top: 0.46rem;
          margin-left: 0.26rem;
          &.cur {
            b {
              display: inline-block;
              width: 0.08rem;
              height: 0.72rem;
              background-color: $mColor;
              position: absolute;
              right: 0;
              top: 0.46rem;
              border-radius: 0.06rem 0 0 0.06rem;
            }
          }
          &.report {
            @include bg-image("../../assets/img/scale/sub/report");
            &.cur {
              @include bg-image("../../assets/img/scale/sub/report_on");
            }
          }
          &.homework {
            @include bg-image("../../assets/img/scale/sub/homework");
            &.cur {
              @include bg-image("../../assets/img/scale/sub/homework_on");
            }
          }
          &.al {
            @include bg-image("../../assets/img/scale/sub/al");
            &.cur {
              @include bg-image("../../assets/img/scale/sub/al_on");
            }
          }
          &.reflect {
            @include bg-image("../../assets/img/scale/sub/reflect");
            &.cur {
              @include bg-image("../../assets/img/scale/sub/reflect_on");
            }
          }
          &.do {
            @include bg-image("../../assets/img/scale/sub/do");
            &.cur {
              @include bg-image("../../assets/img/scale/sub/do_on");
            }
          }
          -webkit-background-size: 100%;
          background-size: 100%;
        }
      }
    }
    .sub_con {
      min-height: calc(100vh - 0.84rem);
      background-color: #f6f6f6;
      padding: 0.36rem 0.48rem 0.48rem 0.54rem;
      width: calc(100% - #{$subNavWidth});
      box-sizing: border-box;
    }
  }
}
</style>
